/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosInstance, AxiosResponse } from "axios";

//Function to get datacenter list data
export function fetchDataCenterList(
  api: AxiosInstance,
  tenantId: number
): Promise<AxiosResponse> {
  return api.get(`/kontroledge/datacenter-interconnect?tenantId=${tenantId}&includeChildServices=true`, {});
}
//Function to fetch the performance for the bandwidth chart with datacenter id
export function fetchDatacenterPerformanceAPI(
    api: AxiosInstance,
    datacenterId: string,
    timeRange: string,
    interval: string,
    tenantId: number,
  ): Promise<AxiosResponse> {
    return api.get(
      `/kontroledge/datacenter-interconnect/${datacenterId}/performance?tenantId=${tenantId}`, {
        params: { timeRange, interval, includeLatency: true },
      });
}

//Function to fetch the datacenter details
export function fetchDatacenterDetailAPI(
  api: AxiosInstance,
  datacenterId: string,
  tenantId: number,
): Promise<AxiosResponse> {
  return api.get(
    `/kontroledge/datacenter-interconnect/${datacenterId}?tenantId=${tenantId}`
  );
}

//Function to fetch the subscription data by datacenter id
export function fetchDatacenterSubscriptionAPI(
  api: AxiosInstance,
  datacenterId: string,
  tenantId: number
): Promise<AxiosResponse> {
  return api.get(
    `/kontroledge/datacenter-interconnect/${datacenterId}/subscription?tenantId=${tenantId}`
  );
}

//Function to get CRC Errors
export function fetchDatacenterErrorsAPI(
    api: AxiosInstance,
    datacenterId: string,
    tenantId: number
  ): Promise<AxiosResponse> {
    return api.get(`/kontroledge/datacenter-interconnect/${datacenterId}/crc-errors?tenantId=${tenantId}`);
  }

//Function to update datacenter name and tag
export function updateDatacenterNameTagAPI(
  api: AxiosInstance,
  datacenterId: string,
  tenantId: number,
  data: { name?: string; tag?: string }
): Promise<AxiosResponse> {
  return api.put(`/kontroledge/datacenter-interconnect/${datacenterId}?tenantId=${tenantId}`, data);
}
